import { Fragment } from 'react';

export function ActionLabel({ text }: { text: string }) {
  return (
    <span className="inline-flex min-w-0 flex-col items-center gap-0.5 text-center">
      {text.split('\n').map((line, index) => (
        <Fragment key={index}>
          {index > 0 && '\n'}
          <span className={index > 0 ? 'block text-[0.8em] font-medium leading-tight' : 'block'}>{line}</span>
        </Fragment>
      ))}
    </span>
  );
}
